import { UnAuthorized, UnAuthorizedMessage } from '../Utility/Constants';
import './NotAuthorized.css'

function NotAuthorized() {
    return (
        <>
            <div className='notAuthorized'>
                <div className='unAuthorized'>{UnAuthorized}</div>
                <p className='unAuthorizedMessage'>{UnAuthorizedMessage}</p>
            </div>
        </>
    )
}

export default NotAuthorized